import React from "react";
import { frontendTrack } from "./track.dto";
import { Link } from "react-router-dom";
function Track1Card() {
  return (
    <div>
      <div className=" m-3 rounded p-3 track">
        <h4 className="align-left">
          Track 1 - <span className="track-name">Web Designing</span>
        </h4>
        <hr className="hr" />
        {frontendTrack.map((track1, index) => (
          <div className="row track-card pt-3 w-70" key={index}>
            <div className="col-4">
              <img
                src={track1.image}
                className="p-0 img-fluid m-0 rounded-start track-img"
                alt=""
              />
            </div>
            <div className="col-6">
              <h5 className="card-title fw-bold">{track1.title}</h5>
              <p className="card-text fw-light mt-2">{track1.description}</p>
           
              <Link
                to={`/track1Detail/${track1.id}`}
                className="btn track-btn align-self-start"
              >
                Detail
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Track1Card;
